/* ============ shared ambient ============
   The old warm sky (yellow radial glow, cotton fluff, OSO hot-air balloon + clouds) stays
   removed per the client revision: minimal, no strong gradients, products are the focus.

   What is back is the flock of birds, on every page. Same silhouette and flap as the hero
   and Our Story skies, so the three read as one world. It sits behind everything, ignores
   pointer events, and drifts across occasionally rather than looping constantly. */
(function () {
  const NS = 'http://www.w3.org/2000/svg';

  /* the sky already draws its own flock; a second one would double up */
  const pageHasOwnFlock = () =>
    !!(document.getElementById('skBirds') || document.querySelector('.flock'));

  function build() {
    if (!window.gsap || pageHasOwnFlock() || document.getElementById('osoBirds')) return;
    /* the homepage hero owns the whole first screen, and Contact was deliberately cleared */
    if (document.getElementById('scene')) return;

    const wrap = document.createElement('div');
    wrap.id = 'osoBirds';
    wrap.setAttribute('aria-hidden', 'true');
    wrap.style.cssText =
      'position:fixed;inset:0;pointer-events:none;z-index:1;overflow:hidden';

    const svg = document.createElementNS(NS, 'svg');
    svg.setAttribute('width', '100%');
    svg.setAttribute('height', '100%');
    svg.setAttribute('viewBox', '0 0 1440 900');
    svg.setAttribute('preserveAspectRatio', 'xMidYMid slice');
    svg.style.cssText = 'position:absolute;inset:0';

    const flock = document.createElementNS(NS, 'g');
    flock.setAttribute('class', 'oso-flock');
    /* one bird = two wing strokes, the shape used everywhere else on the site */
    [[0, 0], [26, -11], [52, -2], [-26, -8], [20, 10]].forEach(p => {
      const b = document.createElementNS(NS, 'g');
      b.setAttribute('class', 'oso-bird');
      b.setAttribute('transform', `translate(${p[0]} ${p[1]})`);
      b.innerHTML = '<path d="M0 0 Q6 -7 12 0 Q6 -3.5 0 0Z M0 0 Q-6 -7 -12 0 Q-6 -3.5 0 0Z" fill="#6a5b7a"/>';
      flock.appendChild(b);
    });
    svg.appendChild(flock);
    wrap.appendChild(svg);
    document.body.appendChild(wrap);

    gsap.set(flock, { opacity: 0.5, scale: 0.72, transformOrigin: '50% 50%' });
    gsap.fromTo(flock,
      { x: 1620, y: 210 },
      { x: -220, y: 150, duration: 26, repeat: -1, repeatDelay: 19, ease: 'none' });
    gsap.to('.oso-bird path',
      { scaleY: 0.42, transformOrigin: '50% 100%', duration: 0.36, repeat: -1, yoyo: true, ease: 'sine.inOut' });
  }

  if (document.readyState === 'loading') addEventListener('DOMContentLoaded', build);
  else build();

  /* existing per-page calls (osoAmbient / osoAmbient({sky:true})) must keep working */
  window.osoAmbient = function () { build(); };
})();
